import { ReactNode } from 'react';
import { NewsPageBySlugQuery, NewsSectionFieldsFragment, NewsArticleFieldsFragment } from '../../@types/generated';
import News from '@/components/News/News';
import NewsArticle from '@/components/NewsArticle/';
import Section from '@/components/Section';

type Props = {
  query: NewsPageBySlugQuery;
};

function renderNewsSection(newsFragment: NewsSectionFieldsFragment): ReactNode {
  return <News data={newsFragment} />;
}

function renderNewsArticle(newsArticleFieldsFragment: NewsArticleFieldsFragment): ReactNode {
  return <NewsArticle data={newsArticleFieldsFragment} />;
}

const NewsArticlePage = ({ query }: Props) => {
  const newsPageCollection = query.newsPageCollection?.items[0];

  if (!newsPageCollection) {
    throw new Error('no news page collection found');
  }

  return (
    <>
      {newsPageCollection.newsArticle && (
        <Section
          childrenTypeName={undefined}
          sectionId={undefined}
          theme={'white-15'}
          marginTop={64}
          marginBottom={64}
          gridType={'full'}
        >
          {renderNewsArticle(newsPageCollection.newsArticle)}
        </Section>
      )}
      {newsPageCollection.relatedNews && (
        <Section
          childrenTypeName={undefined}
          sectionId={undefined}
          theme={'white-100'}
          marginTop={48}
          marginBottom={24}
          gridType={'full'}
        >
          {renderNewsSection(newsPageCollection.relatedNews)}
        </Section>
      )}
    </>
  );
};
export default NewsArticlePage;
